import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import logoIsoFooter from '../assets/images/iso9001.jpg';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();

  const contactData = {
    phone: '+34 628 847 988',
    email: 'info@voltarisindustry.es',
    nif: t('company.nif')
  };

  const esIngles = i18n.language && i18n.language.startsWith('en');

  return (
    <footer className="bg-secondary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Voltaris</h3>
            <p className="text-white/80 mb-4">
              {t('footer.description')}
            </p>
            <p className="text-sm text-white/60">
              NIF: {contactData.nif}
            </p>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-4">{t('contact.info.title')}</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-white/80 flex-shrink-0 mt-1" />
                <div className="text-white/80 text-sm">
                  {t('address.street')}<br />
                  {t('address.postalCode')} {t('address.city')}<br />
                  {t('address.province')}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-white/80 flex-shrink-0" />
                <span className="text-white/80 text-sm">{contactData.phone}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-white/80 flex-shrink-0" />
                <span className="text-white/80 text-sm">{contactData.email}</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors duration-200">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors duration-200">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors duration-200">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/quality-policy" className="text-white/80 hover:text-white transition-colors duration-200">
                  {t('nav.quality')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors duration-200">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col items-center justify-center gap-6">
          <div className="text-center">
            <img 
              src={logoIsoFooter} 
              alt="SGS ISO 9001 Certified" 
              className="h-16 w-auto mx-auto mb-2 rounded-sm"
            />
            <p className="text-[10px] text-white/50 tracking-wider uppercase font-medium">
              {esIngles ? 'Certified Quality System' : 'Sistema de Calidad Certificado'}
            </p>
          </div>

          <div className="text-center">
            <p className="text-white/60 text-sm">
              © {currentYear} Voltaris Industry & Renewable. {t('footer.copyright')}
            </p>
            <div className="mt-2">
				<button 
				  onClick={() => window.dispatchEvent(new Event('openCookieSettings'))}
				  style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit' }}
				>
				  Configuración de Cookies
				</button>
            </div>
            <p className="text-white/40 text-xs mt-1">
              Developed by{' '}
              <a 
                href="https://www.whitecastle-dev.es" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-primary transition-colors duration-200 underline underline-offset-2"
              >
                WhiteCastle Dev
              </a>
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;